module.exports = __webpack_public_path__ + "img/menu-bar-off_06.7c5ee55d.png";